import { render, staticRenderFns } from "./NicePopupView.vue?vue&type=template&id=2bc7ee2a&scoped=true&"
import script from "./NicePopupView.vue?vue&type=script&lang=js&"
export * from "./NicePopupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc7ee2a",
  null
  
)

export default component.exports